import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  noGps: {
    color: theme.palette.error.main,
  },
  highGps: {
    color: theme.palette.success.main,
  },
  lowGps: {
    color: theme.palette.warning.main,
  },
}));
